{
  "familyId": "TGL-GELD-WISSEL",
  "questions": [
    {
      "id": "TGL-GELD-WISSEL-001",
      "familyId": "TGL-GELD-WISSEL",
      "module": "TijdGeld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een snoepje kost €0,75. Je betaalt met €1,00. Hoeveel wisselgeld krijg je?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": [
        "€0,25",
        "€0,75",
        "€0,30",
        "€0,20"
      ],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 75,
          "paidCents": 100,
          "targetCents": 25,
          "allowedDenoms": [
            {
              "valueCents": 50,
              "type": "coin",
              "label": "50 cent"
            },
            {
              "valueCents": 20,
              "type": "coin",
              "label": "20 cent"
            },
            {
              "valueCents": 10,
              "type": "coin",
              "label": "10 cent"
            },
            {
              "valueCents": 5,
              "type": "coin",
              "label": "5 cent"
            }
          ],
          "constraints": {
            "maxTokens": 5
          }
        }
      },
      "conceptId": "give_change_quarters",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "money",
          "data": {
            "amount": 100
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Wisselgeld berekenen",
            "content": "Wisselgeld = betaald − prijs = €1,00 − €0,75 = €0,25. Geef terug: 20 cent + 5 cent = 25 cent."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Reken stap voor stap. Stap 1: je betaalt €1,00 en het snoepje kost €0,75. Stap 2: wisselgeld = €1,00 − €0,75 = €0,25. Stap 3: geef terug: 20 cent + 5 cent = 25 cent.",
        "distractorExplanations": {
          "0": "Correct! Wisselgeld = €1,00 − €0,75 = €0,25.",
          "1": "Veelgemaakte fout: de prijs verwarren met het wisselgeld. €0,75 is de prijs van het snoepje zelf, niet het wisselgeld. Wisselgeld = betaald − prijs = €1,00 − €0,75 = €0,25.",
          "2": "Veelgemaakte fout: verkeerd aftrekken. €0,30 is 5 cent te veel. Controleer: €1,00 − €0,75 = €0,25, niet €0,30.",
          "3": "Veelgemaakte fout: een munt vergeten bij het teruggeven. €0,20 is 5 cent te weinig. Je geeft alleen 20 cent terug, maar je hebt ook nog 5 cent nodig: 20 + 5 = 25 cent."
        }
      }
    },
    {
      "id": "TGL-GELD-WISSEL-002",
      "familyId": "TGL-GELD-WISSEL",
      "module": "TijdGeld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een pen kost €1,25. Je betaalt met €2,00. Hoeveel wisselgeld krijg je terug?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": [
        "€0,75",
        "€1,25",
        "€0,80",
        "€0,70"
      ],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 125,
          "paidCents": 200,
          "targetCents": 75,
          "allowedDenoms": [
            {
              "valueCents": 50,
              "type": "coin",
              "label": "50 cent"
            },
            {
              "valueCents": 20,
              "type": "coin",
              "label": "20 cent"
            },
            {
              "valueCents": 10,
              "type": "coin",
              "label": "10 cent"
            },
            {
              "valueCents": 5,
              "type": "coin",
              "label": "5 cent"
            }
          ],
          "constraints": {
            "maxTokens": 5
          }
        }
      },
      "conceptId": "give_change_euros",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "money",
          "data": {
            "amount": 100
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Wisselgeld met euros",
            "content": "Wisselgeld = €2,00 − €1,25 = €0,75. Geef terug: 50 cent + 20 cent + 5 cent = 75 cent."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Reken stap voor stap. Stap 1: je betaalt €2,00 en de pen kost €1,25. Stap 2: wisselgeld = €2,00 − €1,25 = €0,75. Stap 3: geef terug: 50 cent + 20 cent + 5 cent = 75 cent.",
        "distractorExplanations": {
          "0": "Correct! Wisselgeld = €2,00 − €1,25 = €0,75.",
          "1": "Veelgemaakte fout: de prijs verwarren met het wisselgeld. €1,25 is de prijs van de pen zelf, niet het wisselgeld. Wisselgeld = betaald − prijs = €2,00 − €1,25 = €0,75.",
          "2": "Veelgemaakte fout: verkeerd aftrekken van de centen. €0,80 is 5 cent te veel. Controleer: €2,00 − €1,25 = €0,75, niet €0,80. Let op: 100 − 25 = 75 cent.",
          "3": "Veelgemaakte fout: een munt vergeten bij het teruggeven. €0,70 is 5 cent te weinig. Je geeft 50c + 20c = 70c terug, maar je hebt ook nog 5 cent nodig: 50 + 20 + 5 = 75 cent."
        }
      }
    },
    {
      "id": "TGL-GELD-WISSEL-003",
      "familyId": "TGL-GELD-WISSEL",
      "module": "TijdGeld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een ijsje kost €3,65. Je betaalt met €5,00. Hoeveel wisselgeld krijg je?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": [
        "€1,35",
        "€8,65",
        "€1,45",
        "€3,65"
      ],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 365,
          "paidCents": 500,
          "targetCents": 135,
          "allowedDenoms": [
            {
              "valueCents": 100,
              "type": "coin",
              "label": "€1"
            },
            {
              "valueCents": 50,
              "type": "coin",
              "label": "50 cent"
            },
            {
              "valueCents": 20,
              "type": "coin",
              "label": "20 cent"
            },
            {
              "valueCents": 10,
              "type": "coin",
              "label": "10 cent"
            },
            {
              "valueCents": 5,
              "type": "coin",
              "label": "5 cent"
            }
          ],
          "constraints": {
            "maxTokens": 6
          }
        }
      },
      "conceptId": "give_change_complex",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "money",
          "data": {
            "amount": 100
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Wisselgeld stap voor stap",
            "content": "Wisselgeld = €5,00 − €3,65. Reken: €5,00 − €3,00 = €2,00, dan €2,00 − €0,65 = €1,35. Geef terug: €1 + 20c + 10c + 5c."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Bij grotere bedragen: splits het aftrekken in euro's en centen. Stap 1: €5,00 − €3,00 = €2,00. Stap 2: €2,00 − €0,65 = €1,35. Stap 3: wisselgeld = €1,35. Geef terug: €1 + 20 cent + 10 cent + 5 cent.",
        "distractorExplanations": {
          "0": "Correct! Wisselgeld = €5,00 − €3,65 = €1,35.",
          "1": "Veelgemaakte fout: optellen in plaats van aftrekken. €8,65 = €5,00 + €3,65. Bij wisselgeld moet je aftrekken: betaald − prijs = €5,00 − €3,65 = €1,35.",
          "2": "Veelgemaakte fout: de centen verkeerd aftrekken. €1,45 is 10 cent te veel. Controleer: 100 − 65 = 35 cent (niet 45 cent). Wisselgeld = €1,35.",
          "3": "Veelgemaakte fout: de prijs verwarren met het wisselgeld. €3,65 is de prijs van het ijsje zelf, niet het wisselgeld. Wisselgeld = betaald − prijs = €5,00 − €3,65 = €1,35."
        }
      }
    },
    {
      "id": "TGL-GELD-WISSEL-004",
      "familyId": "TGL-GELD-WISSEL",
      "module": "TijdGeld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een stripboek kost €4,50. Je betaalt met €10,00. Hoeveel wisselgeld krijg je terug?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": [
        "€5,50",
        "€5,00",
        "€6,00",
        "€4,50"
      ],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 450,
          "paidCents": 1000,
          "targetCents": 550,
          "allowedDenoms": [
            {
              "valueCents": 500,
              "type": "bill",
              "label": "€5"
            },
            {
              "valueCents": 200,
              "type": "coin",
              "label": "€2"
            },
            {
              "valueCents": 100,
              "type": "coin",
              "label": "€1"
            },
            {
              "valueCents": 50,
              "type": "coin",
              "label": "50 cent"
            }
          ],
          "constraints": {
            "maxTokens": 5
          }
        }
      },
      "conceptId": "give_change_large",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "money",
          "data": {
            "amount": 100
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Groot wisselgeld",
            "content": "Wisselgeld = €10,00 − €4,50 = €5,50. Reken: €10,00 − €4,00 = €6,00, dan €6,00 − €0,50 = €5,50. Geef terug: €5 biljet + 50 cent."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Bij grotere bedragen: splits in euro's en centen. Stap 1: €10,00 − €4,00 = €6,00. Stap 2: €6,00 − €0,50 = €5,50. Stap 3: wisselgeld = €5,50. Geef terug: €5 biljet + 50 cent.",
        "distractorExplanations": {
          "0": "Correct! Wisselgeld = €10,00 − €4,50 = €5,50.",
          "1": "Veelgemaakte fout: de centen vergeten bij het aftrekken. €5,00 is 50 cent te weinig. Je trekt alleen de euro's af (€10 − €4 = €6... nee: €10,00 − €4,50 = €5,50). Vergeet de 50 cent niet.",
          "2": "Veelgemaakte fout: alleen de euro's aftrekken. €6,00 is 50 cent te veel. Je rekent €10 − €4 = €6, maar vergeet de 50 cent af te trekken: €6,00 − €0,50 = €5,50.",
          "3": "Veelgemaakte fout: de prijs verwarren met het wisselgeld. €4,50 is de prijs van het stripboek zelf, niet het wisselgeld. Wisselgeld = betaald − prijs = €10,00 − €4,50 = €5,50."
        }
      }
    },
    {
      "id": "TGL-GELD-WISSEL-005",
      "familyId": "TGL-GELD-WISSEL",
      "module": "TijdGeld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een drankje kost €2,35. Je betaalt met €5,00. Hoeveel wisselgeld krijg je?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": [
        "€2,65",
        "€2,60",
        "€2,70",
        "€3,00"
      ],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 235,
          "paidCents": 500,
          "targetCents": 265,
          "allowedDenoms": [
            {
              "valueCents": 200,
              "type": "coin",
              "label": "€2"
            },
            {
              "valueCents": 100,
              "type": "coin",
              "label": "€1"
            },
            {
              "valueCents": 50,
              "type": "coin",
              "label": "50 cent"
            },
            {
              "valueCents": 20,
              "type": "coin",
              "label": "20 cent"
            },
            {
              "valueCents": 10,
              "type": "coin",
              "label": "10 cent"
            },
            {
              "valueCents": 5,
              "type": "coin",
              "label": "5 cent"
            }
          ],
          "constraints": {
            "maxTokens": 6
          }
        }
      },
      "conceptId": "give_change_precise",
      "variantIndex": 5,
      "stimulusAids": [
        {
          "type": "money",
          "data": {
            "amount": 100
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Precies wisselgeld",
            "content": "Wisselgeld = €5,00 − €2,35 = €2,65. Reken: €5,00 − €2,00 = €3,00, dan €3,00 − €0,35 = €2,65. Geef terug: €2 + 50c + 10c + 5c."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Bij grotere bedragen: splits in euro's en centen. Stap 1: €5,00 − €2,00 = €3,00. Stap 2: €3,00 − €0,35 = €2,65. Stap 3: wisselgeld = €2,65. Geef terug: €2 + 50 cent + 10 cent + 5 cent.",
        "distractorExplanations": {
          "0": "Correct! Wisselgeld = €5,00 − €2,35 = €2,65.",
          "1": "Veelgemaakte fout: een munt vergeten bij het teruggeven. €2,60 is 5 cent te weinig. Je geeft €2 + 50c + 10c = €2,60 terug, maar je hebt ook nog 5 cent nodig.",
          "2": "Veelgemaakte fout: de centen verkeerd aftrekken. €2,70 is 5 cent te veel. Controleer: 100 − 35 = 65 cent (niet 70 cent). Wisselgeld = €2,65.",
          "3": "Veelgemaakte fout: alleen de euro's aftrekken. €3,00 is te veel — je rekent €5 − €2 = €3, maar vergeet de 35 cent af te trekken: €3,00 − €0,35 = €2,65."
        }
      }
    },
    {
      "id": "TGL-GELD-WISSEL-006",
      "familyId": "TGL-GELD-WISSEL",
      "module": "TijdGeld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een kaartje kost €6,80. Je betaalt met €10,00. Hoeveel wisselgeld krijg je terug?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": [
        "€3,20",
        "€3,00",
        "€3,30",
        "€4,00"
      ],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 680,
          "paidCents": 1000,
          "targetCents": 320,
          "allowedDenoms": [
            {
              "valueCents": 200,
              "type": "coin",
              "label": "€2"
            },
            {
              "valueCents": 100,
              "type": "coin",
              "label": "€1"
            },
            {
              "valueCents": 50,
              "type": "coin",
              "label": "50 cent"
            },
            {
              "valueCents": 20,
              "type": "coin",
              "label": "20 cent"
            },
            {
              "valueCents": 10,
              "type": "coin",
              "label": "10 cent"
            }
          ],
          "constraints": {
            "maxTokens": 6
          }
        }
      },
      "conceptId": "give_change_twenties",
      "variantIndex": 6,
      "stimulusAids": [
        {
          "type": "money",
          "data": {
            "amount": 100
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Wisselgeld met 20 cent",
            "content": "Wisselgeld = €10,00 − €6,80 = €3,20. Reken: €10,00 − €6,00 = €4,00, dan €4,00 − €0,80 = €3,20. Geef terug: €2 + €1 + 20c."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Bij grotere bedragen: splits in euro's en centen. Stap 1: €10,00 − €6,00 = €4,00. Stap 2: €4,00 − €0,80 = €3,20. Stap 3: wisselgeld = €3,20. Geef terug: €2 + €1 + 20 cent.",
        "distractorExplanations": {
          "0": "Correct! Wisselgeld = €10,00 − €6,80 = €3,20.",
          "1": "Veelgemaakte fout: de centen vergeten bij het aftrekken. €3,00 is 20 cent te weinig. Je trekt alleen de euro's af (€10 − €7 = €3), maar vergeet de 80 cent correct af te trekken.",
          "2": "Veelgemaakte fout: de centen verkeerd aftrekken. €3,30 is 10 cent te veel. Controleer: 100 − 80 = 20 cent (niet 30 cent). Wisselgeld = €3,20.",
          "3": "Veelgemaakte fout: alleen de euro's aftrekken. €4,00 is te veel — je rekent €10 − €6 = €4, maar vergeet de 80 cent af te trekken: €4,00 − €0,80 = €3,20."
        }
      }
    },
    {
      "id": "TGL-GELD-WISSEL-007",
      "familyId": "TGL-GELD-WISSEL",
      "module": "TijdGeld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "fill_in",
      "question": "Je koopt een broodje van €3,50 en betaalt met een briefje van €5. Hoeveel wisselgeld krijg je terug?",
      "options": [
        "€1,50",
        "€1,00",
        "€2,00",
        "€2,50"
      ],
      "correctAnswer": 0,
      "data": {
        "fill_in": {
          "inputType": "text",
          "placeholder": "€0,00",
          "unit": "",
          "acceptedAnswers": [
            "€1,50",
            "1,50",
            "1.50",
            "150"
          ]
        },
        "money": {
          "mode": "give_change",
          "priceCents": 350,
          "paidCents": 500,
          "targetCents": 150,
          "currency": "EUR"
        }
      },
      "supportAids": [
        {
          "type": "money",
          "showWhen": "correct",
          "data": {
            "amount": 150,
            "showCoins": true,
            "showBills": false,
            "label": "Wisselgeld: €1,50"
          }
        }
      ],
      "conceptId": "money_change_calculation",
      "variantIndex": 7,
      "stimulusAids": [
        {
          "type": "money",
          "data": {
            "amount": 100
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wisselgeld = betaald − prijs. Stap 1: je betaalt €5,00 en het broodje kost €3,50. Stap 2: €5,00 − €3,50 = €1,50. Stap 3: geef terug: €1 + 50 cent = €1,50."
      }
    }
  ]
}